// DO NOT EDIT: autogenerated by brokkr
import { CreateIconOptions } from "./types";
export const falGripLinesVertical: CreateIconOptions = {
  "displayName": "FALGripLinesVertical",
  "viewBox": "0, 0, 192, 512",
  "d": "M32 32c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16L48 48c0-8.8-7.2-16-16-16zm128 0c-8.8 0-16 7.2-16 16l0 416c0 8.8 7.2 16 16 16s16-7.2 16-16l0-416c0-8.8-7.2-16-16-16z"
};
